import React from 'react'
import { Routes, Route } from "react-router-dom";
import Snapshot from './Pages/snapshot';
import News from './Pages/news';

function AppRoutes() {
  return (
    <>
      <Routes>
          <Route path="/gorunum" element={<Snapshot />} /> 
        <Route path="/snapshot" element={<Snapshot />} />
        <Route path="/haberler" element={<News />} /> 
        <Route path="/news" element={<News />} />
      </Routes>
    </>
  )
}

export default AppRoutes
